<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Términos y Condiciones</li>
      </template>
      <template slot="title">
        Términos y Condiciones
      </template>
      <template slot="body">
        <TermsContract />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import TermsContract from "@components/contracts/TermsContract/TermsContract-05-2022.vue";
import GenericPage from "./new-portal-views/GenericPage.vue";

export default {
  name: "TermsContractPage",
  components: {
    TermsContract,
    GenericPage
  }
}
</script>

<style scoped>

</style>